<template>
  <div>
    <h1>Information about {{ countryName }}</h1>
    <div v-for="(country, index) in currentCountry" :key="index">
      <CountryCard :country="country">
        <a-card-meta title="Common name:">
          <template slot="description"> {{ country.name.common }} </template>
        </a-card-meta>
        <a-card-meta title="Currency:">
          <template slot="description"> {{ country.currency[0] }} </template>
        </a-card-meta>
      </CountryCard>
    </div>
  </div>
</template>

<script>
import CountryCard from '@/components/countries/CountryCard.vue';
import axios from 'axios';
export default {
  components: {
    CountryCard,
  },
  props: {
    countryName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentCountry: null,
    };
  },
  methods: {
    getCountry() {
      const serverAPI = 'http://countries-finder-api.webtraining.fun';
      const url = `${serverAPI}/countries/search`;
      const serviceURL = `${url}/${this.countryName}`;

      const alternativeServerAPI = 'https://restcountries.eu';
      const alternativeUrl = `${alternativeServerAPI}/rest/v2/name`;
      const alternativeServiceURL = `${alternativeUrl}/${this.countryName}`;

      Promise.any([axios.get(serviceURL), axios.get(alternativeServiceURL)])
        .then((response) => {
          if (response.config.url.includes('webtraining')) {
            this.currentCountry = response.data;
          } else {
            this.currentCountry = response.data.map(
              ({ name: common, alpha2Code: cca2, flag, currencies }) => ({
                name: {
                  common,
                },
                cca2,
                flag: flag,
                currency: [currencies[0].code],
              })
            );
          }
          this.loading = false;
        })
        .catch((e) => {
          console.error(e.message);
          this.loading = false;
          this.$message.config({ top: '68px' });
          this.$message.error(e.message);
        });
    },
  },
  created() {
    this.getCountry();
  },
};
</script>

<style lang="scss" scoped></style>
